/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 29th 2024, 10:47:10 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

export const AssetListSkeleton = () => (
  <Grid container>
    {Array(12)
      .fill(0)
      .map((t, index) => (
        <Grid item xs={12} md={3}>
          <Skeleton key={`${index}`} height="250px" sx={{ padding: "4px", margin: "8px", transform: "scale(1,1)" }} />
        </Grid>
      ))}
  </Grid>
);
